// src/core/lib/api/client.ts — HTTP client core (PRI-291 Phase 7 → PRI-439 R13)
//
// R13 (design Part III §26): the transport under EVERY core API module is now
// the published @primate-intelligence/sdk HttpClient — the same client a
// customer gets (C3). The legacy request() signature is preserved exactly so
// zero component changes are needed; endpoints not yet wrapped by the SDK go
// through its raw-body escape hatch. Auth stays the opaque token registry
// (setTokenGetter/getAuthToken — components register the Clerk resolver, the
// SDK resolves per request; §24 first-party-as-peer auth).

export { API_BASE_URL } from './base'
export { setTokenGetter, getAuthToken } from './token'
import { sdk } from './sdk'
import { PrimateError } from '@primate-intelligence/sdk/browser'

export async function request<T>(path: string, options?: RequestInit & { skipContentType?: boolean }): Promise<T> {
  const { skipContentType, ...fetchOptions } = (options ?? {}) as RequestInit & { skipContentType?: boolean }
  const method = (fetchOptions.method ?? 'GET') as 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE'
  try {
    return await sdk.http.requestRaw<T>(method, path, {
      body: fetchOptions.body ?? undefined,
      headers: {
        ...(skipContentType ? {} : { 'Content-Type': 'application/json' }),
        ...(fetchOptions.headers as Record<string, string> | undefined),
      },
      signal: fetchOptions.signal ?? undefined,
    })
  } catch (e) {
    if (e instanceof PrimateError) {
      // Preserve the legacy error shape components already handle:
      // message = server error.message verbatim, plus { code, status, upgradeUrl }.
      const fallback = /^HTTP \d+$/.test(e.rawMessage) ? `API error: ${e.status}` : e.rawMessage
      throw Object.assign(new Error(fallback), {
        code: e.code,
        status: e.status,
        upgradeUrl: (e.details as { upgrade_url?: string } | undefined)?.upgrade_url,
      })
    }
    throw e
  }
}
